module.exports = __webpack_public_path__ + "static/service-banner-loading-6dda662d8f1b78865097dc7452c17b24.jpeg";